jQuery(document).ready(function ($) {
    $('.js-menu-toggle').on('click', function () {
        $('body').toggleClass('is-menu-on');
    });

    $('.open-sub-menu').click(function () {
        var parent = $(this).closest('.menu-item');
        parent.toggleClass('visible');
    });
    $('.compare-table th').on('click', function () {
        $(this).toggleClass('th-close');
    });
});


(function($) {
    function setup_collapsible_submenus() {
        $( "<div class='sub-menu-toggle'></div>" ).insertBefore( "#main-header #mobile_menu.et_mobile_menu .menu-item-has-children > a" );
        $( "#main-header #mobile_menu.et_mobile_menu .sub-menu-toggle" ).click(function () {
            $(this).toggleClass("popped");
        });
    }
    $(document).ready(function() {
        setup_collapsible_submenus();
    });
    $(window).load(function() {
        setup_collapsible_submenus();
    });
})(jQuery);